import { Pipe, PipeTransform } from '@angular/core';
import { TipoSolicitudHelper } from '../../helpers/solicitudes/TipoSolicitudHelper';

@Pipe({
    name: 'typeRequestNumberToStringPipe',
    standalone: false
})
export class TypeRequestNumberToStringPipe implements PipeTransform {

  transform(value: string | number): string {
    return TipoSolicitudHelper.obtenerNombreTipo(value);
  }
}